import SignIn from "../components/SignIn/SignIn";
import Requests from "../components/Requests/Requests";
import Request from "../components/Request/Request";
import Users from "../components/Users/Users";
import Districts from "../components/Districts/Districts";
import District from "../components/District/District";


const routes: RouteType[] = [
  {path: '/sign-in', component: SignIn, auth: false},
  {path: '/', component: Requests, auth: true },
  {path: '/request/:id', component: Request, auth: true },
  {path: '/users', component: Users, auth: true },
  {path: '/districts', component: Districts, auth: true },
  {path: '/districts/:id', component: District, auth: true },
]

interface RouteType {
  path: string
  component: React.FC<any>
  auth: boolean
  props?: object
  breadcrumb?: string | null
}

export default routes
